import { DeviceWithOutStatusOutputData } from './device-with-out-status-output-data.model';


export class DeviceSelectByIdOutput implements IDeviceSelectByIdOutput {
    status!: number;
    message!: string;
    data!: DeviceWithOutStatusOutputData;

    constructor(data?: IDeviceSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? DeviceWithOutStatusOutputData.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeviceSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IDeviceSelectByIdOutput {
    status: number;
    message: string;
    data: DeviceWithOutStatusOutputData;
}

